(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["austpek-request-a-quote"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-apq-app]');

    roots.forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const section = root.closest('.apq');
      const form = root.closest('form');
      const sectionId = section.dataset.sectionId;
      const storageKey = `austpek-rfq-${sectionId}`;
      const routesRoot = window.Shopify?.routes?.root || '/';
      const moneyFormat = section.dataset.moneyFormat || window.theme?.moneyFormat || '${{amount}}';
      const state = {
        route: '',
        panel: '',
        cart: null,
        includedKeys: new Set(),
        reviewedSignature: '',
        searchTimer: null,
        searchController: null,
        hasInclusionSelection: false,
        isSubmitting: false,
        isUpdatingCart: false,
        isAddingProduct: false,
        productModalOpen: false,
        restoreSearchFocus: false,
        modalCache: new Map(),
        modalToken: 0
      };

      const labels = {
        decrease: section.dataset.labelDecrease || 'Decrease quantity',
        increase: section.dataset.labelIncrease || 'Increase quantity',
        quantity: section.dataset.labelQuantity || 'Quantity',
        remove: section.dataset.labelRemove || 'Remove',
        add: section.dataset.labelAdd || 'Add to quote',
        adding: section.dataset.labelAdding || 'Adding…',
        added: section.dataset.labelAdded || 'Added to your quote.'
      };

      const query = (selector, scope = root) => scope.querySelector(selector);
      const queryAll = (selector, scope = root) => Array.from(scope.querySelectorAll(selector));
      const startScreen = query('[data-screen="start"]');
      const flowScreen = query('[data-screen="flow"]');
      const successScreen = query('[data-screen="success"]');
      const notice = query('[data-notice]');
      const summaryCount = query('[data-summary-count]');
      const summaryContent = query('[data-summary-content]');
      const summaryEditWrap = query('[data-summary-edit-wrap]');
      const quoteBodyField = query('[data-quote-body]');
      const routeField = query('[data-route-field]');
      const productCountField = query('[data-product-count-field]');
      const referenceField = query('[data-quote-reference]');
      const contactNameField = query('[data-contact-name]');
      const productsNeededField = query('[data-products-needed-field]');
      const productModal = section.querySelector('[data-apq-product-modal]');
      const productModalInner = section.querySelector('[data-apq-product-modal-inner]');
      const productModalOpenButton = section.querySelector('[data-apq-open-modal]');
      const productModalNotice = section.querySelector('[data-apq-modal-notice]');

      const showModalNotice = (message) => {
        if (!productModalNotice) return;
        productModalNotice.textContent = message;
        productModalNotice.hidden = !message;
      };

      const hideModalNotice = () => showModalNotice('');

      const createElement = (tag, className, text) => {
        const element = document.createElement(tag);
        if (className) element.className = className;
        if (text !== undefined) element.textContent = text;
        return element;
      };

      const isPresent = (value) => value !== null && value !== undefined && String(value).trim() !== '';

      const formatWithDelimiters = (cents, precision, thousands, decimal) => {
        const amountCents = Number(cents);
        const safeCents = Number.isFinite(amountCents) ? amountCents : 0;
        const value = (Math.abs(safeCents) / 100).toFixed(precision);
        const parts = value.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        const formatted = parts.length > 1 ? `${parts[0]}${decimal}${parts[1]}` : parts[0];
        return safeCents < 0 ? `-${formatted}` : formatted;
      };

      const money = (cents) => {
        const format = moneyFormat;
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          try {
            return window.Shopify.formatMoney(cents, format);
          } catch (error) {
            // Fall through to the local formatter.
          }
        }
        const tokenMatch = format.match(/\{\{\s*(\w+)\s*\}\}/);
        const token = tokenMatch ? tokenMatch[1] : 'amount';
        let value = '';
        switch (token) {
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0, ',', '.');
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
          case 'amount_with_apostrophe_separator':
            value = formatWithDelimiters(cents, 2, "'", '.');
            break;
          default:
            value = formatWithDelimiters(cents, 2, ',', '.');
        }
        return format.replace(/\{\{\s*\w+\s*\}\}/, value);
      };

      const formatBudget = (value) => {
        if (!isPresent(value)) return '';
        const number = Number(value);
        if (!Number.isFinite(number)) return String(value);
        return money(number * 100);
      };

      const publicProperties = (item) => Object.entries(item.properties || {}).filter(([key, value]) => {
        return isPresent(value) && !String(key).startsWith('_');
      });

      const allProperties = (item) => Object.entries(item.properties || {}).filter(([, value]) => isPresent(value));

      const includedItems = () => {
        if (!state.cart?.items) return [];
        return state.cart.items;
      };

      const cartSignature = () => {
        if (!state.cart?.items) return '';
        return JSON.stringify(state.cart.items.map((item) => ({
          key: item.key,
          quantity: item.quantity,
          final_line_price: item.final_line_price,
          properties: item.properties || {}
        })));
      };

      const showNotice = (message) => {
        notice.textContent = message;
        notice.hidden = !message;
        if (message) notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };

      const hideNotice = () => showNotice('');

      const getFormSnapshot = () => {
        const fields = queryAll('input[name], textarea[name], select[name]', form);
        const values = {};
        fields.forEach((field) => {
          if (field.type === 'hidden' || field.name === 'contact[body]') return;
          if (field.type === 'checkbox') {
            if (!values[field.name]) values[field.name] = [];
            if (field.checked) values[field.name].push(field.value);
            return;
          }
          if (field.type === 'radio') {
            if (field.checked) values[field.name] = field.value;
            return;
          }
          values[field.name] = field.value;
        });
        return values;
      };

      const saveDraft = () => {
        try {
          sessionStorage.setItem(storageKey, JSON.stringify({
            route: state.route,
            panel: state.panel,
            includedKeys: Array.from(state.includedKeys),
            reviewedSignature: state.reviewedSignature,
            values: getFormSnapshot()
          }));
          if (state.route) sessionStorage.setItem('austpek-rfq-route', state.route);
          if (state.panel) sessionStorage.setItem('austpek-rfq-panel', state.panel);
        } catch (error) {
          return;
        }
      };

      const readDraft = () => {
        try {
          return JSON.parse(sessionStorage.getItem(storageKey) || 'null');
        } catch (error) {
          return null;
        }
      };

      const restoreValues = (values = {}) => {
        Object.entries(values).forEach(([name, value]) => {
          const fields = queryAll(`[name="${CSS.escape(name)}"]`, form);
          fields.forEach((field) => {
            if (field.type === 'checkbox') {
              field.checked = Array.isArray(value) ? value.includes(field.value) : value === field.value;
            } else if (field.type === 'radio') {
              field.checked = field.value === value;
            } else {
              field.value = value || '';
            }
          });
        });

        const legacyProducts = values['contact[Products needed][]'];
        if (!values.package_product && legacyProducts) {
          const selected = Array.isArray(legacyProducts) ? legacyProducts : [legacyProducts];
          queryAll('[data-package-product]', form).forEach((field) => {
            field.checked = selected.includes(field.value);
          });
        }
      };

      const setStep = (step) => {
        queryAll('[data-step-indicator]').forEach((indicator) => {
          const number = Number(indicator.dataset.stepIndicator);
          indicator.classList.toggle('is-active', number === step);
          indicator.classList.toggle('is-complete', number < step);
        });
      };

      const panelStep = (panel) => {
        if (panel === 'project') return 2;
        if (panel === 'contact') return 3;
        return 1;
      };

      const showPanel = (panel, options = {}) => {
        state.panel = panel;
        startScreen.hidden = true;
        successScreen.hidden = true;
        flowScreen.hidden = false;
        queryAll('[data-panel]').forEach((element) => {
          element.hidden = element.dataset.panel !== panel;
        });
        setStep(panelStep(panel));
        summaryEditWrap.hidden = panel !== 'contact';
        updateSummary();
        hideNotice();
        saveDraft();
        if (!options.noScroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      const showStart = () => {
        state.route = '';
        state.panel = '';
        flowScreen.hidden = true;
        successScreen.hidden = true;
        startScreen.hidden = false;
        hideNotice();
        query('[data-cart-switch-confirm]')?.setAttribute('hidden', '');
        saveDraft();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      const updateStepOneLabel = () => {
        const label = query('[data-step-one-label]');
        label.textContent = state.route === 'build' ? 'Brief' : 'Products';
      };

      const syncRouteControls = () => {
        queryAll('[data-panel="build"] input[name], [data-panel="build"] textarea[name], [data-panel="build"] select[name]')
          .forEach((field) => { field.disabled = state.route !== 'build'; });
      };

      const markQuoteStarted = (route) => {
        try {
          sessionStorage.setItem('austpek-rfq-started', '1');
          if (route) sessionStorage.setItem('austpek-rfq-route', route);
        } catch (error) {
          // Session storage may be unavailable.
        }
        try {
          document.cookie = 'austpek-rfq-started=1;path=/;max-age=604800;SameSite=Lax';
        } catch (error) {
          // Cookie may be unavailable.
        }
        if (window.RQ && typeof window.RQ.markStarted === 'function') {
          window.RQ.markStarted(route);
        } else if (window.RQ && typeof window.RQ.syncTriggers === 'function') {
          window.RQ.syncTriggers();
        }
      };

      const wipeQuoteStorage = () => {
        const keys = [
          'austpek-rfq-quote',
          'austpek-rfq-started',
          'austpek-rfq-route',
          'austpek-rfq-panel',
          storageKey,
          `${storageKey}-reference`
        ];
        for (const key of keys) {
          try {
            sessionStorage.removeItem(key);
          } catch (error) {
            // Ignore storage failures.
          }
          try {
            localStorage.removeItem(key);
          } catch (error) {
            // Ignore storage failures.
          }
        }
        try {
          document.cookie = 'austpek-rfq-started=;path=/;max-age=0;SameSite=Lax';
        } catch (error) {
          // Ignore cookie failures.
        }
      };

      const resetQuoteState = () => {
        state.route = '';
        state.panel = '';
        state.cart = null;
        state.includedKeys = new Set();
        state.reviewedSignature = '';
        state.hasInclusionSelection = false;
        state.isSubmitting = false;
        state.isUpdatingCart = false;
        state.isAddingProduct = false;
        if (typeof form.reset === 'function') form.reset();
      };

      const applyRqClear = () => {
        if (!window.RQ) return;
        if (typeof window.RQ.clear === 'function') window.RQ.clear();
        else if (typeof window.RQ.clearStarted === 'function') window.RQ.clearStarted();
        if (typeof window.RQ.close === 'function') window.RQ.close();
        if (typeof window.RQ.syncTriggers === 'function') window.RQ.syncTriggers();
      };

      const resetQuoteFlow = () => {
        wipeQuoteStorage();
        resetQuoteState();
        if (window.RQ) {
          applyRqClear();
          return;
        }
        document.addEventListener('rq:ready', applyRqClear, { once: true });
      };

      const startRoute = async (route, options = {}) => {
        query('[data-cart-switch-confirm]')?.setAttribute('hidden', '');
        state.route = route;
        markQuoteStarted(route);
        updateStepOneLabel();
        routeField.value = route === 'cart' ? 'Use my cart' : route === 'add' ? 'Add products' : 'Build my package';
        syncRouteControls();
        let quoteLoaded = true;
        if (route === 'cart') {
          quoteLoaded = await refreshQuote({ preserveSelection: true, silent: true, importFromCart: true });
        } else if (route === 'add') {
          quoteLoaded = await refreshQuote({ preserveSelection: true, silent: true });
        }
        if (state.route !== route) return;
        showPanel(route, options);
        if (!quoteLoaded) {
          showNotice(
            route === 'cart'
              ? 'We could not load your cart. Please refresh and try again.'
              : 'We could not load your quote. Please refresh and try again.'
          );
        }
      };

      const appendImage = (container, source, alt, className) => {
        if (source) {
          const image = document.createElement('img');
          image.className = className;
          image.src = source;
          image.alt = alt || '';
          image.loading = 'lazy';
          container.appendChild(image);
        } else {
          const placeholder = createElement('span', `${className} ${className}-placeholder`, '—');
          placeholder.setAttribute('aria-hidden', 'true');
          container.appendChild(placeholder);
        }
      };

      const appendPropertyList = (container, item) => {
        const properties = publicProperties(item);
        if (!properties.length) return;
        const heading = createElement('span', 'apq__item-meta', 'Selected options');
        container.appendChild(heading);
        const list = createElement('dl', 'apq__property-list');
        properties.forEach(([key, value]) => {
          const term = createElement('dt', '', key);
          const detail = createElement('dd');
          const stringValue = String(value);
          if (/^https?:\/\//i.test(stringValue)) {
            const link = createElement('a', '', 'View uploaded option');
            link.href = stringValue;
            link.target = '_blank';
            link.rel = 'noopener';
            detail.appendChild(link);
          } else {
            detail.textContent = stringValue;
          }
          list.append(term, detail);
        });
        container.appendChild(list);
      };

      const createIcon = (type) => {
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('focusable', 'false');
        svg.setAttribute('role', 'presentation');
        svg.setAttribute('aria-hidden', 'true');
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('fill', 'currentColor');
        if (type === 'minus') {
          svg.setAttribute('class', 'apq__icon--minus');
          svg.setAttribute('viewBox', '0 0 10 2');
          path.setAttribute('d', 'M10 0v2H0V0z');
        } else {
          svg.setAttribute('class', 'apq__icon--plus');
          svg.setAttribute('viewBox', '0 0 10 10');
          path.setAttribute('d', 'M6 4h4v2H6v4H4V6H0V4h4V0h2v4z');
          path.setAttribute('fill-rule', 'evenodd');
        }
        svg.appendChild(path);
        return svg;
      };

      const createItemCard = (item) => {
        const article = createElement('article', 'apq__item');
        article.dataset.lineKey = item.key;
        appendImage(article, item.image, item.product_title || item.title, 'apq__item-image');

        const copy = createElement('div', 'apq__item-copy');
        const title = createElement('div', 'apq__item-title');
        const link = createElement('a', '', item.product_title || item.title || 'Product');
        link.href = item.url || '#';
        link.target = '_blank';
        link.rel = 'noopener';
        title.appendChild(link);
        copy.appendChild(title);

        const metaParts = [];
        if (item.variant_title && item.variant_title !== 'Default Title') metaParts.push(item.variant_title);
        if (item.sku) metaParts.push(`SKU ${item.sku}`);
        if (metaParts.length) copy.appendChild(createElement('div', 'apq__item-meta', metaParts.join(' · ')));
        appendPropertyList(copy, item);
        if (item.unavailable) {
          copy.appendChild(createElement('p', 'apq__item-unavailable', 'No longer available — remove or contact us to substitute.'));
        }
        article.appendChild(copy);

        const side = createElement('div', 'apq__item-side');
        side.appendChild(createElement('strong', 'apq__item-price', money(item.final_line_price)));

        const qtyControls = createElement('div', 'apq__qty-controls');
        const selector = createElement('div', 'apq__quantity-selector');

        const decreaseButton = document.createElement('button');
        decreaseButton.type = 'button';
        decreaseButton.className = 'apq__quantity-button';
        decreaseButton.dataset.apqQtyChange = String(Math.max(item.quantity - 1, 0));
        decreaseButton.dataset.lineKey = item.key;
        decreaseButton.setAttribute('aria-label', labels.decrease);
        decreaseButton.title = labels.decrease;
        decreaseButton.appendChild(createIcon('minus'));

        const quantityInput = document.createElement('input');
        quantityInput.className = 'apq__quantity-value';
        quantityInput.type = 'number';
        quantityInput.inputMode = 'numeric';
        quantityInput.min = '0';
        quantityInput.step = '1';
        quantityInput.value = String(item.quantity);
        quantityInput.dataset.apqQtyInput = 'true';
        quantityInput.dataset.lineKey = item.key;
        quantityInput.dataset.currentValue = String(item.quantity);
        quantityInput.setAttribute('aria-label', labels.quantity);

        const increaseButton = document.createElement('button');
        increaseButton.type = 'button';
        increaseButton.className = 'apq__quantity-button';
        increaseButton.dataset.apqQtyChange = String(item.quantity + 1);
        increaseButton.dataset.lineKey = item.key;
        increaseButton.setAttribute('aria-label', labels.increase);
        increaseButton.title = labels.increase;
        increaseButton.appendChild(createIcon('plus'));

        selector.append(decreaseButton, quantityInput, increaseButton);
        qtyControls.appendChild(selector);

        const removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.className = 'apq__remove-line';
        removeButton.dataset.apqQtyChange = '0';
        removeButton.dataset.lineKey = item.key;
        removeButton.textContent = labels.remove;
        qtyControls.appendChild(removeButton);
        side.appendChild(qtyControls);
        article.appendChild(side);
        return article;
      };

      const setLineControlsDisabled = (disabled) => {
        queryAll('[data-apq-qty-change], [data-apq-qty-input]', root).forEach((control) => {
          control.disabled = disabled;
        });
      };

      const renderCart = () => {
        const cartItems = query('[data-cart-items]');
        const addItems = query('[data-add-items]');
        const cartEmpty = query('[data-cart-empty]');
        const addEmpty = query('[data-add-empty]');
        cartItems.replaceChildren();
        addItems.replaceChildren();

        const items = state.cart?.items || [];
        items.forEach((item) => {
          cartItems.appendChild(createItemCard(item));
          addItems.appendChild(createItemCard(item));
        });

        cartEmpty.hidden = items.length > 0;
        addEmpty.hidden = items.length > 0;
        queryAll('[data-panel="cart"] [data-next="project"], [data-panel="add"] [data-next="project"]')
          .forEach((button) => { button.disabled = includedItems().length === 0; });
        query('[data-panel="build"] [data-next="project"]').disabled = false;
        updateSummary();
      };

      const waitForRQ = () => {
        if (window.RQ && typeof window.RQ.toCartShape === 'function') {
          return Promise.resolve(window.RQ);
        }
        return new Promise((resolve, reject) => {
          const timeout = window.setTimeout(() => {
            document.removeEventListener('rq:ready', onReady);
            reject(new Error('Quote store unavailable'));
          }, 4000);
          const onReady = () => {
            window.clearTimeout(timeout);
            resolve(window.RQ);
          };
          document.addEventListener('rq:ready', onReady, { once: true });
        });
      };

      const applyQuoteToState = (options = {}) => {
        state.cart = window.RQ.toCartShape();
        state.includedKeys = new Set((state.cart.items || []).map((item) => item.key));
        state.hasInclusionSelection = true;
        renderCart();
        saveDraft();
      };

      // "Add products" quote items live only in RQ's own store, never the real Shopify cart,
      // so nothing re-prices or re-checks availability for them on its own. Re-fetch each
      // distinct product and reconcile price/availability so Refresh actually catches repriced
      // or discontinued items instead of just re-rendering the same stored data.
      const reconcileCatalog = async () => {
        const items = window.RQ.getItems();
        const handles = Array.from(new Set(items.map((item) => item.handle).filter(Boolean)));
        if (!handles.length) return { changed: false, unavailableCount: 0 };

        const productByHandle = new Map();
        await Promise.all(handles.map(async (handle) => {
          try {
            const response = await fetch(`${routesRoot}products/${encodeURIComponent(handle)}.js`, {
              credentials: 'same-origin',
              headers: { Accept: 'application/json' }
            });
            productByHandle.set(handle, response.ok ? await response.json() : null);
          } catch (error) {
            productByHandle.set(handle, null);
          }
        }));

        let changed = false;
        let unavailableCount = 0;
        for (const item of items) {
          const product = item.handle ? productByHandle.get(item.handle) : null;
          const variant = product?.variants?.find((candidate) => String(candidate.id) === String(item.variant_id));
          const patch = {};
          if (!product || !variant) {
            if (!item.unavailable) patch.unavailable = true;
          } else {
            if (item.unavailable) patch.unavailable = false;
            if (!variant.available) patch.unavailable = true;
            const optionPrice = Number(item.option_price) || 0;
            const currentPrice = (Number(variant.price) || 0) + optionPrice;
            if (currentPrice !== Number(item.price)) {
              patch.price = currentPrice;
              patch.original_price = Number(variant.price) || 0;
              patch.option_price = optionPrice;
              patch.line_price = currentPrice * item.quantity;
              patch.final_line_price = currentPrice * item.quantity;
            }
          }
          if (Object.keys(patch).length) {
            window.RQ.updateItem(item.key, patch);
            changed = true;
          }
          const isUnavailable = patch.unavailable !== undefined ? patch.unavailable : item.unavailable;
          if (isUnavailable) unavailableCount += 1;
        }
        return { changed, unavailableCount };
      };

      const refreshQuote = async (options = {}) => {
        try {
          await waitForRQ();
          let unavailableCount = 0;
          if (options.importFromCart) {
            await window.RQ.importCart();
          } else if (options.reconcileCatalog) {
            ({ unavailableCount } = await reconcileCatalog());
          }
          applyQuoteToState(options);
          if (!options.silent) {
            if (unavailableCount > 0) {
              showNotice(
                unavailableCount === 1
                  ? 'Products refreshed. 1 item is no longer available.'
                  : `Products refreshed. ${unavailableCount} items are no longer available.`
              );
            } else {
              showNotice(options.importFromCart
                ? 'Products refreshed from your cart.'
                : 'Products refreshed.');
            }
          }
          return true;
        } catch (error) {
          if (!options.silent) {
            showNotice(options.importFromCart
              ? 'We could not refresh your cart. Please try again.'
              : 'We could not refresh your quote. Please try again.');
          }
          return false;
        }
      };

      const changeLineQuantity = async (lineKey, quantity) => {
        if (state.isUpdatingCart || !lineKey) return false;
        const nextQuantity = Number(quantity);
        if (!Number.isFinite(nextQuantity) || nextQuantity < 0) return false;

        state.isUpdatingCart = true;
        setLineControlsDisabled(true);
        hideNotice();

        try {
          await waitForRQ();
          window.RQ.updateQuantity(lineKey, nextQuantity);
          applyQuoteToState({ preserveSelection: true });
          return true;
        } catch (error) {
          showNotice(error?.message || 'We could not update that product. Please try again.');
          applyQuoteToState({ preserveSelection: true });
          return false;
        } finally {
          state.isUpdatingCart = false;
          setLineControlsDisabled(false);
        }
      };

      const selectedValue = (name) => query(`[name="${CSS.escape(name)}"]:checked`, form)?.value || '';

      const selectedValues = (selector) => queryAll(`${selector}:checked`, form).map((field) => field.value);

      const syncProductsNeededField = () => {
        if (!productsNeededField) return;
        productsNeededField.value = selectedValues('[data-package-product]').join(', ');
      };

      // Phone contact is only offered once a phone number is entered; without one the
      // radio is disabled and any existing phone preference falls back to email.
      const syncPreferredContact = () => {
        const phoneField = query('[data-contact-phone]');
        const phoneRadio = query('[data-preferred-phone]');
        if (!phoneField || !phoneRadio) return;
        const hasPhone = phoneField.value.trim().length > 0;
        const choice = phoneRadio.closest('[data-preferred-phone-choice]');
        const hint = query('[data-preferred-phone-hint]');
        phoneRadio.disabled = !hasPhone;
        choice?.classList.toggle('is-disabled', !hasPhone);
        if (hint) hint.hidden = hasPhone;
        if (hasPhone || !phoneRadio.checked) return;
        phoneRadio.checked = false;
        const emailRadio = query('[name="contact[Preferred contact]"][value="Email"]');
        if (emailRadio) emailRadio.checked = true;
      };

      const updateSummary = () => {
        summaryContent.replaceChildren();
        const items = includedItems();
        const count = state.route === 'build' ? selectedValues('[data-package-product]').length : items.length;
        summaryCount.textContent = state.route === 'build'
          ? `${count} ${count === 1 ? 'product group' : 'product groups'}`
          : `${count} ${count === 1 ? 'item' : 'items'}`;

        if (!state.route) {
          summaryContent.appendChild(createElement('p', 'apq__summary-meta', 'Choose how you would like to start.'));
          return;
        }

        if (state.route === 'build') {
          const list = createElement('ul', 'apq__summary-list');
          const space = selectedValue('contact[Space]') || 'Not selected';
          const products = selectedValues('[data-package-product]');
          const budget = query('[data-budget-input]')?.value || '';
          [
            ['Space', space],
            ['Product groups', products.length ? String(products.length) : 'Not selected'],
            ['Budget', budget ? formatBudget(budget) : 'Not supplied']
          ].forEach(([label, value]) => {
            const item = createElement('li');
            item.append(createElement('span', '', label), createElement('span', '', value));
            list.appendChild(item);
          });
          summaryContent.appendChild(list);
          return;
        }

        if (!items.length) {
          summaryContent.appendChild(createElement('p', 'apq__summary-meta', 'No products selected yet.'));
          return;
        }

        const total = items.reduce((sum, item) => sum + Number(item.final_line_price || 0), 0);
        const totalRow = createElement('div', 'apq__summary-total');
        totalRow.append(createElement('span', '', 'Selected products subtotal'), createElement('span', '', money(total)));
        summaryContent.appendChild(totalRow);

        const list = createElement('ul', 'apq__summary-list');
        items.slice(0, 5).forEach((item) => {
          const row = createElement('li');
          row.append(
            createElement('span', '', item.product_title || item.title || 'Product'),
            createElement(
              'span',
              '',
              publicProperties(item).length ? `Configured · Qty ${item.quantity}` : `Qty ${item.quantity}`
            )
          );
          list.appendChild(row);
        });
        if (items.length > 5) list.appendChild(createElement('li', 'apq__summary-meta', `+ ${items.length - 5} more`));
        summaryContent.appendChild(list);
        summaryContent.appendChild(createElement('p', 'apq__summary-meta', 'Guide only. Final pricing is confirmed in your tailored quote.'));
      };

      const clearErrors = (scope) => {
        queryAll('[aria-invalid="true"]', scope).forEach((field) => field.removeAttribute('aria-invalid'));
        queryAll('.apq__fieldset.is-invalid', scope).forEach((group) => {
          group.classList.remove('is-invalid');
          group.removeAttribute('aria-invalid');
        });
        queryAll('.apq__field-error', scope).forEach((error) => { error.hidden = true; });
      };

      const markGroupInvalid = (group) => {
        group.classList.add('is-invalid');
        group.setAttribute('aria-invalid', 'true');
        queryAll('input[type="checkbox"], input[type="radio"]', group).forEach((input) => {
          input.setAttribute('aria-invalid', 'true');
        });
        const error = query(`[data-group-error="${group.dataset.requiredGroup}"]`, group);
        if (error) error.hidden = false;
      };

      const clearGroupInvalid = (group) => {
        group.classList.remove('is-invalid');
        group.removeAttribute('aria-invalid');
        queryAll('input[type="checkbox"], input[type="radio"]', group).forEach((input) => {
          input.removeAttribute('aria-invalid');
        });
        const error = query(`[data-group-error="${group.dataset.requiredGroup}"]`, group);
        if (error) error.hidden = true;
      };

      const validateRequiredFields = (panel) => {
        clearErrors(panel);
        let valid = true;
        let firstInvalid = null;
        queryAll('input, textarea, select', panel).forEach((field) => {
          if (field.type === 'hidden' || !field.willValidate || field.checkValidity()) return;
          valid = false;
          firstInvalid ||= field;
          field.setAttribute('aria-invalid', 'true');
          const error = field.closest('.apq__field')?.querySelector('.apq__field-error');
          if (error) error.hidden = false;
        });
        queryAll('[data-required-field]', panel).forEach((field) => {
          const value = field.value.trim();
          const isEmail = field.type === 'email';
          const fieldValid = value && field.checkValidity() && (!isEmail || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value));
          if (!fieldValid) {
            valid = false;
            firstInvalid ||= field;
            field.setAttribute('aria-invalid', 'true');
            const error = field.closest('.apq__field')?.querySelector('.apq__field-error');
            if (error) error.hidden = false;
          }
        });
        queryAll('[data-required-group]', panel).forEach((group) => {
          const checked = query('input:checked', group);
          if (!checked) {
            valid = false;
            markGroupInvalid(group);
            firstInvalid ||= query('input[type="checkbox"], input[type="radio"]', group) || group;
          }
        });
        if (firstInvalid) {
          if (typeof firstInvalid.reportValidity === 'function' && firstInvalid.willValidate && !firstInvalid.checkValidity()) {
            firstInvalid.reportValidity();
          } else if (typeof firstInvalid.focus === 'function') {
            firstInvalid.focus({ preventScroll: true });
          }
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return valid;
      };

      const validateStepOne = () => {
        const panel = query(`[data-panel="${state.route}"]`);
        if (state.route === 'build') return validateRequiredFields(panel);
        const valid = includedItems().length > 0;
        const error = query(state.route === 'cart' ? '[data-cart-error]' : '[data-add-error]');
        error.hidden = valid;
        return valid;
      };

      const validateContact = () => {
        const panel = query('[data-panel="contact"]');
        syncPreferredContact();
        let valid = validateRequiredFields(panel);
        const consent = query('[data-consent]');
        const consentError = query('[data-consent-error]');
        if (!consent.checked) {
          valid = false;
          consentError.hidden = false;
        } else {
          consentError.hidden = true;
        }
        return valid;
      };

      const createReference = () => {
        try {
          const saved = sessionStorage.getItem(`${storageKey}-reference`);
          if (saved) return saved;
        } catch (error) {
          // Continue with an in-memory reference when storage is unavailable.
        }
        const date = new Date();
        const stamp = [
          String(date.getFullYear()).slice(-2),
          String(date.getMonth() + 1).padStart(2, '0'),
          String(date.getDate()).padStart(2, '0')
        ].join('');
        const reference = `AQ-${stamp}-${Math.random().toString(36).slice(2, 7).toUpperCase()}`;
        try {
          sessionStorage.setItem(`${storageKey}-reference`, reference);
        } catch (error) {
          // The hidden contact field still carries this reference to Shopify.
        }
        return reference;
      };

      const buildQuoteBody = () => {
        const lines = [];
        lines.push(`AUSTPEK QUOTE REQUEST`);
        lines.push(`Reference: ${referenceField.value}`);
        lines.push(`Route: ${routeField.value}`);
        lines.push('');

        if (state.route === 'build') {
          lines.push('PACKAGE BRIEF');
          lines.push(`Space: ${selectedValue('contact[Space]')}`);
          lines.push(`Products needed: ${selectedValues('[data-package-product]').join(', ')}`);
          const budget = query('[data-budget-input]')?.value || '';
          lines.push(`Approximate product budget: ${budget ? formatBudget(budget) : 'Not supplied'}`);
        } else {
          lines.push('CONFIGURED PRODUCTS');
          includedItems().forEach((item, index) => {
            lines.push(`${index + 1}. ${item.product_title || item.title || 'Product'}`);
            lines.push(`Line key: ${item.key}`);
            lines.push(`Variant: ${item.variant_title || 'Default'}`);
            lines.push(`Variant ID: ${item.variant_id || item.id || ''}`);
            lines.push(`SKU: ${item.sku || 'Not supplied'}`);
            lines.push(`Quantity: ${item.quantity}`);
            lines.push(`Line price: ${money(item.final_line_price)}`);
            const productUrl = item.url ? new URL(item.url, window.location.origin).href : '';
            lines.push(`Product URL: ${productUrl}`);
            const properties = allProperties(item);
            if (properties.length) {
              lines.push('Line item properties:');
              properties.forEach(([key, value]) => lines.push(`- ${key}: ${String(value)}`));
            } else {
              lines.push('Line item properties: None');
            }
            if (item.selling_plan_allocation?.selling_plan?.name) {
              lines.push(`Selling plan: ${item.selling_plan_allocation.selling_plan.name}`);
            }
            lines.push('');
          });
          lines.push(`Selected products subtotal: ${money(includedItems().reduce((sum, item) => sum + Number(item.final_line_price || 0), 0))}`);
        }

        lines.push('');
        lines.push('PROJECT');
        lines.push(`Postcode: ${query('[name="contact[Project postcode]"]')?.value || ''}`);
        lines.push(`Timing: ${selectedValue('contact[Timing]')}`);
        lines.push(`Notes: ${query('[name="contact[Project notes]"]')?.value || 'Not supplied'}`);
        lines.push('');
        lines.push('This quote request does not place an order, reserve stock or change the customer cart.');
        return lines.join('\n');
      };

      const renderSearchResults = (products) => {
        const container = query('[data-search-results]');
        const status = query('[data-search-status]');
        container.replaceChildren();
        if (!products.length) {
          status.textContent = 'No matching products found.';
          return;
        }
        status.textContent = `${products.length} ${products.length === 1 ? 'product' : 'products'} found.`;
        products.forEach((product) => {
          const handle = getProductHandle(product);
          const article = createElement('article', 'apq__result');
          const imageUrl = product.featured_image?.url || product.image || '';
          appendImage(article, imageUrl, product.featured_image?.alt || product.title, 'apq__result-image');
          const copy = createElement('div', 'apq__result-copy');
          const title = createElement('div', 'apq__result-title');
          const titleLink = createElement('a', '', product.title);
          titleLink.href = product.url || (handle ? `${routesRoot}products/${handle}` : '#');
          titleLink.target = '_blank';
          titleLink.rel = 'noopener';
          title.appendChild(titleLink);
          copy.appendChild(title);
          if (isPresent(product.price)) {
            copy.appendChild(createElement('span', 'apq__result-price', `From ${money(Number(product.price) * 100)}`));
          }
          article.appendChild(copy);

          const action = document.createElement('button');
          action.type = 'button';
          action.className = 'apq__result-action';
          action.textContent = labels.add;
          action.setAttribute('aria-label', `${labels.add}: ${product.title}`);
          action.dataset.addProduct = 'true';
          action.dataset.productHandle = handle;
          action.dataset.productUrl = product.url || (handle ? `${routesRoot}products/${handle}` : '');
          action.dataset.productTitle = product.title || '';
          if (!handle && !action.dataset.productUrl) action.disabled = true;
          article.appendChild(action);
          container.appendChild(article);
        });
      };

      const getProductHandle = (product) => {
        if (product?.handle) return product.handle;
        if (!product?.url) return '';
        try {
          const path = new URL(product.url, window.location.origin).pathname;
          const match = path.match(/\/products\/([^/?#]+)/);
          return match ? decodeURIComponent(match[1]) : '';
        } catch (error) {
          return '';
        }
      };

      const extractQuoteProduct = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fromView = doc.querySelector('[data-apq-quote-product]');
        if (fromView) return document.importNode(fromView, true);

        const templates = Array.from(doc.querySelectorAll('template'));
        for (const template of templates) {
          const node = template.content.querySelector('[data-section-type="product-quick-view"], [data-apq-quote-product]');
          if (node) return document.importNode(node, true);
        }

        const fallback = doc.querySelector('[data-section-type="product-quick-view"]');
        return fallback ? document.importNode(fallback, true) : null;
      };

      const extractAndRunScripts = (html, container) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('script').forEach((sourceScript) => {
          if (sourceScript.src) return;
          const script = document.createElement('script');
          script.textContent = sourceScript.textContent;
          (container || document.body).appendChild(script);
          script.remove();
        });
      };

      const reinitalizeVoOptions = (container) => {
        const productId = container?.dataset?.productId;
        try {
          if (typeof window.bcpo_product !== 'undefined' && productId) {
            if (Array.isArray(window.bcpo_product)) {
              const match = window.bcpo_product.find((item) => String(item.id) === String(productId));
              if (match) window.bcpo_product = match;
            }
          }

          if (typeof window.bcpo?.reload === 'function') window.bcpo.reload();
          if (typeof window.bcpo?.refresh === 'function') window.bcpo.refresh();
          if (typeof window.bcpo?.init === 'function') window.bcpo.init();
          if (typeof window.BCPO?.init === 'function') window.BCPO.init();
          if (typeof window.BCPO?.load === 'function') window.BCPO.load();

          document.dispatchEvent(new CustomEvent('bcpo:load', { detail: { productId } }));
          document.dispatchEvent(new CustomEvent('vo:options:reload', { detail: { productId } }));

          const placeholder = container?.querySelector('.bcpo-quickview, #bcpo');
          if (placeholder) {
            placeholder.setAttribute('data-apq-vo-ready', String(Date.now()));
          }

          // Re-run VO/BCPO front scripts that may only bind on first paint.
          document.querySelectorAll('script[src*="bcpo"], script[src*="productoption"], script[src*="product-option"], script[src*="relentless"]').forEach((source) => {
            if (!source.src || source.dataset.apqVoRerun === 'true') return;
            const script = document.createElement('script');
            script.src = `${source.src}${source.src.includes('?') ? '&' : '?'}apq=${Date.now()}`;
            script.async = true;
            script.dataset.apqVoRerun = 'true';
            document.body.appendChild(script);
          });
        } catch (error) {
          // VO reinits are best-effort; form still works for plain variants.
        }
      };

      const prepareQuoteProductForm = (container) => {
        const quoteRoot = container.querySelector('[data-apq-quote-product]') || container;
        const form = quoteRoot.querySelector('form[action*="/cart/add"]');

        container.querySelectorAll('[data-action="add-to-cart"]').forEach((button) => {
          button.textContent = labels.add;
          button.setAttribute('aria-label', labels.add);
        });
        bindQuoteProductGallery(quoteRoot);

        if (!form || form.dataset.apqAjaxBound === 'true') return;
        form.dataset.apqAjaxBound = 'true';

        // Keep the shopper on the quote page; add to quote storage instead of the Shopify cart.
        const addToQuoteViaAjax = async (button) => {
          if (state.isAddingProduct) return;
          if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
            const invalidField = form.querySelector(':invalid');
            const groupLabel = invalidField
              ?.closest('.selector-wrapper')
              ?.querySelector('.bcpo-title')
              ?.textContent
              ?.replace(/:\s*$/, '')
              .trim();
            showModalNotice(
              groupLabel
                ? `Choose an option for "${groupLabel}" before adding this to your quote.`
                : 'Choose the required options before adding this to your quote.'
            );
            return;
          }
          hideModalNotice();

          const submitButton =
            button ||
            form.querySelector('[data-action="add-to-cart"]') ||
            form.querySelector('[type="submit"]');
          const originalLabel = submitButton?.textContent;
          state.isAddingProduct = true;

          if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent = labels.adding;
          }

          try {
            await waitForRQ();
            await window.RQ.addItemFromForm(form, {
              product_id: quoteRoot.getAttribute('data-product-id'),
              handle: quoteRoot.getAttribute('data-product-handle'),
              product_title: quoteRoot.getAttribute('data-product-title'),
              url: quoteRoot.getAttribute('data-product-url'),
              image: quoteRoot.getAttribute('data-product-image'),
              source: 'quote-page'
            });
            window.RQ.markStarted(state.route || 'add');

            const quantity = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10) || 1;
            document.dispatchEvent(
              new CustomEvent('product:added', {
                bubbles: true,
                detail: { quantity, button: submitButton }
              })
            );
          } catch (error) {
            showNotice(error?.message || 'Could not add that product. Please try again.');
          } finally {
            state.isAddingProduct = false;
            if (submitButton) {
              submitButton.disabled = false;
              if (originalLabel) submitButton.textContent = originalLabel;
            }
          }
        };

        form.addEventListener(
          'submit',
          (event) => {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            addToQuoteViaAjax(event.submitter);
          },
          true
        );

        form.addEventListener(
          'click',
          (event) => {
            const button = event.target.closest('[data-action="add-to-cart"], [type="submit"]');
            if (!button || !form.contains(button) || button.disabled) return;
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            addToQuoteViaAjax(button);
          },
          true
        );
      };

      const enlargeImageUrl = (url) => {
        if (!url) return null;
        try {
          const path = url.split('?')[0];
          const parts = path.split('/');
          const encoded = parts[parts.length - 1];
          if (!encoded) return url;
          const decoded = JSON.parse(atob(encoded));
          if (!decoded?.edits?.resize) return url;
          decoded.edits.resize.width = Math.max(Number(decoded.edits.resize.width) || 200, 900);
          parts[parts.length - 1] = btoa(JSON.stringify(decoded));
          return parts.join('/');
        } catch (error) {
          return url;
        }
      };

      const isLikelyImageUrl = (url) => {
        if (!url || url.startsWith('#')) return false;
        try {
          const parsed = new URL(url, window.location.origin);
          return (
            /\.(jpe?g|png|gif|webp|svg|avif)(\?|$)/i.test(parsed.pathname) ||
            parsed.hostname.includes('cdn.shopify') ||
            parsed.hostname.includes('shopifycdn') ||
            parsed.pathname.includes('/files/') ||
            parsed.pathname.includes('/products/')
          );
        } catch (error) {
          return false;
        }
      };

      const bindQuoteProductGallery = (root) => {
        if (!root || root.dataset.apqGalleryBound === 'true') return;
        root.dataset.apqGalleryBound = 'true';

        const stageImage = root.querySelector('[data-apq-stage-image]');
        if (!stageImage) return;

        const setStageImage = (url, alt) => {
          const nextUrl = enlargeImageUrl(url) || url;
          if (!nextUrl) return;
          stageImage.src = nextUrl;
          stageImage.removeAttribute('srcset');
          if (alt) stageImage.alt = alt;
        };

        const syncThumbSelection = (activeThumb) => {
          root.querySelectorAll('[data-apq-thumb]').forEach((thumb) => {
            const selected = thumb === activeThumb;
            thumb.classList.toggle('is-selected', selected);
            thumb.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
        };

        const neutralizeVoImageLinks = () => {
          root.querySelectorAll('#bcpo a[href], .bcpo-quickview a[href]').forEach((link) => {
            const href = link.getAttribute('href') || '';
            if (!isLikelyImageUrl(href) && !isLikelyImageUrl(link.href)) return;
            if (!link.dataset.apqImageHref) {
              link.dataset.apqImageHref = href || link.href;
            }
            link.setAttribute('href', '#');
            link.removeAttribute('target');
            link.removeAttribute('download');
          });
        };

        // The VO/BCPO widget renders connector/finish choices as image swatches with no
        // visible name and no usable accessible name on the radio itself (each radio's own
        // "value" attribute already holds the full option text, just never surfaced). Add a
        // visible caption and an aria-label so sighted and screen-reader shoppers can both
        // tell the options apart.
        const labelVoImageOptions = () => {
          root.querySelectorAll('#bcpo .selector-wrapper.bcpo-images, .bcpo-quickview .selector-wrapper.bcpo-images').forEach((wrapper) => {
            const groupLabel = wrapper.querySelector('.bcpo-title')?.textContent?.replace(/:\s*$/, '').trim() || '';
            wrapper.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach((input) => {
              const optionName = (input.value || '').trim();
              if (!optionName) return;
              input.setAttribute('aria-label', groupLabel ? `${groupLabel}: ${optionName}` : optionName);

              const label = wrapper.querySelector(`label[for="${input.id}"]`) || input.closest('.bcpo-image-parent')?.querySelector('label');
              if (!label) return;
              const image = label.querySelector('img');
              if (image && !image.alt) image.alt = optionName;

              // The image label is a fixed-size swatch, so the caption sits beside it as a
              // sibling. Make that caption a second <label for> and click the host padding
              // so the whole option card selects the radio, not just the picture.
              const captionHost = input.closest('.bcpo-image-parent') || label.parentElement;
              if (!captionHost) return;

              if (!input.id) {
                input.id = `apq-vo-option-${sectionId}-${Math.random().toString(36).slice(2, 9)}`;
                label.setAttribute('for', input.id);
              }

              let caption = captionHost.querySelector('[data-apq-option-caption]');
              if (!caption) {
                caption = document.createElement('label');
                caption.className = 'apq__vo-option-caption';
                caption.dataset.apqOptionCaption = 'true';
                caption.textContent = optionName;
                captionHost.appendChild(caption);
              } else if (caption.tagName !== 'LABEL') {
                const captionLabel = document.createElement('label');
                captionLabel.className = caption.className;
                captionLabel.dataset.apqOptionCaption = 'true';
                captionLabel.textContent = caption.textContent || optionName;
                caption.replaceWith(captionLabel);
                caption = captionLabel;
              }
              caption.setAttribute('for', input.id);

              if (captionHost.dataset.apqOptionClickable !== 'true') {
                captionHost.dataset.apqOptionClickable = 'true';
                captionHost.addEventListener('click', (event) => {
                  if (input.disabled) return;
                  if (event.target.closest('input, label, button, a')) return;
                  input.click();
                });
              }
            });
          });
        };

        const hideVoPriceNotes = () => {
          const pattern = /selection will add|will add .* to price|adds? .* to (the )?price/i;
          root.querySelectorAll('#bcpo *, .bcpo-quickview *').forEach((node) => {
            if (node.children.length > 0) return;
            const text = (node.textContent || '').trim();
            if (!text || !pattern.test(text)) return;
            const hideTarget = node.closest('p, span, div, small, em, strong, label') || node;
            hideTarget.setAttribute('data-apq-hide-price-note', 'true');
          });
        };

        neutralizeVoImageLinks();
        hideVoPriceNotes();
        labelVoImageOptions();

        // Observe `root` itself, not the #bcpo node: the VO/BCPO widget can replace that whole
        // element (not just mutate its children) while rendering, which would silently detach
        // an observer scoped to the original #bcpo reference and stop it from ever firing again.
        if (typeof MutationObserver === 'function') {
          const observer = new MutationObserver(() => {
            neutralizeVoImageLinks();
            hideVoPriceNotes();
            labelVoImageOptions();
          });
          observer.observe(root, { childList: true, subtree: true });
        }

        root.addEventListener(
          'click',
          (event) => {
            const thumb = event.target.closest('[data-apq-thumb]');
            if (thumb && root.contains(thumb)) {
              event.preventDefault();
              setStageImage(thumb.dataset.imageUrl, thumb.dataset.imageAlt);
              syncThumbSelection(thumb);
              return;
            }

            // Keep VO option selection working, but never navigate to option image URLs
            // and never swap the main gallery image from option clicks.
            const bcpoHit = event.target.closest('#bcpo a, .bcpo-quickview a');
            if (!bcpoHit || !root.contains(bcpoHit)) return;

            const href = bcpoHit.dataset.apqImageHref || bcpoHit.getAttribute('href') || '';
            if (href === '#' || isLikelyImageUrl(href) || isLikelyImageUrl(bcpoHit.href)) {
              event.preventDefault();
            }
          },
          true
        );
      };

      const closeProductModal = () => {
        state.productModalOpen = false;
        state.isAddingProduct = false;
        if (productModal?.getAttribute('aria-hidden') === 'false') {
          document.dispatchEvent(new CustomEvent('modal:close'));
        }
        productModal?.classList.remove('is-loading');
        // Keep the rendered product markup (and any third-party option widget it holds) in
        // state.modalCache rather than wiping it, so reopening the same product reuses the
        // already-initialised options instead of depending on a third-party script that only
        // renders once per page load.
      };

      const openProductModal = async (button) => {
        const handle = button.dataset.productHandle;
        const productUrl = handle
          ? `${routesRoot}products/${encodeURIComponent(handle)}?view=apq-quote`
          : (button.dataset.productUrl || '');
        if (!productUrl || state.isAddingProduct) return;

        // Invalidate any still-in-flight fetch/render from a previously opened product so a
        // slow response can't land after the user has already moved on to a different one.
        const token = ++state.modalToken;
        hideModalNotice();

        const originalLabel = button.textContent;
        button.disabled = true;
        button.textContent = labels.adding;
        state.isAddingProduct = true;
        state.productModalOpen = true;

        const cached = state.modalCache.get(productUrl);
        if (cached) {
          productModalInner.replaceChildren(cached);
          productModal.classList.remove('is-loading');
          productModalOpenButton?.click();
          state.isAddingProduct = false;
          button.disabled = false;
          button.textContent = originalLabel;
          return;
        }

        productModal.classList.add('is-loading');
        productModalInner.replaceChildren();
        productModalOpenButton?.click();

        try {
          const response = await fetch(productUrl, {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!response.ok) throw new Error('Product request failed');
          const html = await response.text();
          if (state.modalToken !== token) return;

          // The VO/BCPO options widget keeps its rendered/selected state on window globals
          // (window.bcpo, its "already ran" flags, per-product data, etc.) and never fully
          // re-initialises once one of those flags is set. Left in place, rendering a second,
          // different product either silently no-ops (leaving #bcpo empty) or restores the
          // previous product's selected configuration and expanded option groups onto the new
          // one. Clear every bcpo-prefixed global before the bootstrap script runs so each new
          // product starts from a genuinely clean widget instead of inheriting the last one's.
          Object.keys(window)
            .filter((key) => /bcpo/i.test(key))
            .forEach((key) => {
              try {
                delete window[key];
              } catch (error) {
                window[key] = undefined;
              }
            });
          delete window.inventory_quantity;

          // Bootstrap VO globals before the form mounts.
          extractAndRunScripts(html);
          if (state.modalToken !== token) return;

          const quoteProduct = extractQuoteProduct(html);
          if (!quoteProduct) throw new Error('Quote product view unavailable');

          productModalInner.replaceChildren(quoteProduct);
          prepareQuoteProductForm(productModalInner);
          productModal.classList.remove('is-loading');
          state.modalCache.set(productUrl, quoteProduct);

          // A single immediate pass only: the previous retried re-injections (at +400ms/+1200ms)
          // could fire after the shopper had already closed this product and opened a different
          // one, re-running the vendor script against whichever product's globals were current
          // by then and corrupting that other product's rendered options.
          reinitalizeVoOptions(productModalInner.querySelector('[data-apq-quote-product]') || productModalInner);
        } catch (error) {
          if (state.modalToken !== token) return;
          closeProductModal();
          productModalInner.replaceChildren();
          showNotice('We could not load that product. Please try again.');
        } finally {
          // Only clear the shared "in progress" flag if a newer open hasn't already claimed it
          // (e.g. the shopper closed this product before it finished loading and opened another).
          if (state.modalToken === token) state.isAddingProduct = false;
          button.disabled = false;
          button.textContent = originalLabel;
        }
      };

      const clearProductSearch = () => {
        window.clearTimeout(state.searchTimer);
        state.searchTimer = null;
        if (state.searchController) {
          state.searchController.abort();
          state.searchController = null;
        }

        const searchInput = query('[data-product-search]');
        const status = query('[data-search-status]');
        const results = query('[data-search-results]');

        if (searchInput) searchInput.value = '';
        if (status) status.textContent = '';
        if (results) results.replaceChildren();
      };

      const handleProductAddedToQuote = async () => {
        if (!state.productModalOpen) return;
        state.restoreSearchFocus = true;
        try {
          await waitForRQ();
          applyQuoteToState({ preserveSelection: true });
          closeProductModal();
          showNotice(labels.added);
        } catch (error) {
          closeProductModal();
          showNotice('Product added, but we could not refresh the list. Use Refresh products.');
        } finally {
          clearProductSearch();
        }
      };

      const searchProducts = async (term) => {
        const status = query('[data-search-status]');
        const results = query('[data-search-results]');
        if (state.searchController) state.searchController.abort();
        if (term.trim().length < 2) {
          status.textContent = '';
          results.replaceChildren();
          return;
        }
        state.searchController = new AbortController();
        const requestedTerm = term.trim();
        status.textContent = 'Searching…';
        try {
          const params = new URLSearchParams({
            q: requestedTerm,
            'resources[type]': 'product',
            'resources[limit]': '6',
            'resources[options][unavailable_products]': 'last',
            'resources[options][fields]': 'title,product_type,variants.title,vendor,variants.sku'
          });
          const response = await fetch(`${routesRoot}search/suggest.json?${params.toString()}`, {
            headers: { Accept: 'application/json' },
            signal: state.searchController.signal,
            credentials: 'same-origin'
          });
          if (!response.ok) throw new Error('Search failed');
          const data = await response.json();
          if (query('[data-product-search]').value.trim() !== requestedTerm) return;
          const products = data.resources?.results?.products || [];
          renderSearchResults(products);
        } catch (error) {
          if (error.name === 'AbortError') return;
          results.replaceChildren();
          status.textContent = 'Search is unavailable right now. Browse the catalogue and return here after adding products.';
        }
      };

      const cartSwitchConfirm = query('[data-cart-switch-confirm]');

      const hideCartSwitchConfirm = () => {
        if (cartSwitchConfirm) cartSwitchConfirm.hidden = true;
      };

      const showCartSwitchConfirm = () => {
        if (!cartSwitchConfirm) return;
        cartSwitchConfirm.hidden = false;
        cartSwitchConfirm.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };

      // Starting from the cart replaces the whole quote item list (see RQ.importCart). If the
      // shopper already has quote items that didn't come from the cart, switching routes here
      // would silently destroy that work, so confirm first instead of clobbering it.
      const hasNonCartQuoteItems = () => {
        if (!window.RQ || typeof window.RQ.getItems !== 'function') return false;
        return window.RQ.getItems().some((item) => item.source !== 'cart');
      };

      queryAll('[data-route]').forEach((button) => {
        button.addEventListener('click', () => {
          if (button.dataset.route === 'cart' && hasNonCartQuoteItems()) {
            showCartSwitchConfirm();
            return;
          }
          startRoute(button.dataset.route);
        });
      });

      query('[data-cart-switch-cancel]')?.addEventListener('click', hideCartSwitchConfirm);
      query('[data-cart-switch-confirm-yes]')?.addEventListener('click', () => {
        hideCartSwitchConfirm();
        startRoute('cart');
      });

      queryAll('[data-switch-route]').forEach((button) => {
        button.addEventListener('click', () => startRoute(button.dataset.switchRoute));
      });

      queryAll('[data-back-start]').forEach((button) => button.addEventListener('click', showStart));

      queryAll('[data-refresh-cart]').forEach((button) => {
        button.addEventListener('click', async () => {
          if (button.disabled) return;
          const originalLabel = button.textContent;
          button.disabled = true;
          button.textContent = 'Refreshing…';
          try {
            await refreshQuote({
              preserveSelection: true,
              importFromCart: state.route === 'cart',
              reconcileCatalog: state.route === 'add'
            });
          } finally {
            button.disabled = false;
            button.textContent = originalLabel;
          }
        });
      });

      queryAll('[data-next="project"]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!validateStepOne()) return;
          state.reviewedSignature = state.route === 'build' ? '' : cartSignature();
          showPanel('project');
        });
      });

      query('[data-next="contact"]').addEventListener('click', () => {
        const projectPanel = query('[data-panel="project"]');
        if (!validateRequiredFields(projectPanel)) return;
        showPanel('contact');
      });

      queryAll('[data-back]').forEach((button) => {
        button.addEventListener('click', () => {
          const target = button.dataset.back === 'step-one' ? state.route : button.dataset.back;
          showPanel(target);
        });
      });

      queryAll('[data-summary-edit]').forEach((button) => {
        button.addEventListener('click', () => {
          showPanel(button.dataset.summaryEdit === 'products' ? state.route : 'project');
        });
      });

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-apq-qty-input]')) {
          const input = event.target;
          const nextQuantity = Number.parseInt(input.value, 10);
          if (!Number.isFinite(nextQuantity) || nextQuantity < 0) {
            input.value = input.dataset.currentValue || '1';
            return;
          }
          changeLineQuantity(input.dataset.lineKey, nextQuantity);
          return;
        }

        if (event.target.matches('[data-contact-phone]')) syncPreferredContact();

        const group = event.target.closest('[data-required-group]');
        if (group && query('input:checked', group)) clearGroupInvalid(group);
        if (event.target.matches('[data-package-product]')) syncProductsNeededField();

        updateSummary();
        saveDraft();
      });

      root.addEventListener('input', (event) => {
        if (event.target.matches('[data-apq-qty-input]')) return;
        if (event.target.matches('[data-contact-phone]')) syncPreferredContact();
        updateSummary();
        saveDraft();
      });

      const searchInput = query('[data-product-search]');
      searchInput.addEventListener('input', () => {
        window.clearTimeout(state.searchTimer);
        state.searchTimer = window.setTimeout(() => searchProducts(searchInput.value), 280);
      });

      root.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && event.target.matches('[data-apq-qty-input]')) {
          event.preventDefault();
          event.target.blur();
        }
      });

      root.addEventListener('click', (event) => {
        const quantityControl = event.target.closest('[data-apq-qty-change]');
        if (quantityControl) {
          event.preventDefault();
          changeLineQuantity(quantityControl.dataset.lineKey, quantityControl.dataset.apqQtyChange);
          return;
        }

        const addButton = event.target.closest('[data-add-product]');
        if (addButton) {
          event.preventDefault();
          openProductModal(addButton);
        }
      });

      document.addEventListener('product:added', () => {
        handleProductAddedToQuote();
      });

      productModal?.addEventListener('modal:closed', () => {
        state.productModalOpen = false;
        productModal.classList.remove('is-loading');
        // Leave productModalInner's content in place (see closeProductModal) so the cached
        // node keeps its rendered options and selections for the next reopen.
        if (!state.restoreSearchFocus) return;
        state.restoreSearchFocus = false;
        query('[data-product-search]')?.focus();
      });

      form.addEventListener('submit', async (event) => {
        if (state.isSubmitting) return;
        event.preventDefault();
        if (!validateContact()) return;
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        if (state.route === 'build' && !validateStepOne()) {
          showPanel('build', { noScroll: true });
          const buildPanel = query('[data-panel="build"]');
          const invalid = query('[aria-invalid="true"]', buildPanel) || query('.apq__fieldset.is-invalid', buildPanel);
          invalid?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (invalid && typeof invalid.focus === 'function') invalid.focus({ preventScroll: true });
          return;
        }

        const submittedRoute = state.route;
        state.isSubmitting = true;
        query('[data-submit-quote]').disabled = true;
        const resetSubmitting = () => {
          state.isSubmitting = false;
          query('[data-submit-quote]').disabled = false;
          queryAll('[data-package-product]', form).forEach((field) => { field.disabled = false; });
        };

        if (state.route !== 'build') {
          const previousSignature = state.reviewedSignature;
          const refreshed = await refreshQuote({ preserveSelection: true, silent: true });
          if (!refreshed) {
            resetSubmitting();
            showNotice('We could not verify the current quote. Please refresh and try again.');
            return;
          }
          if (state.route !== submittedRoute || state.panel !== 'contact') {
            resetSubmitting();
            return;
          }
          if (previousSignature && previousSignature !== cartSignature()) {
            resetSubmitting();
            showPanel(state.route, { noScroll: true });
            showNotice('Your quote changed since you reviewed it. Check the products and selected options before continuing.');
            return;
          }
          if (!includedItems().length) {
            resetSubmitting();
            showPanel(state.route, { noScroll: true });
            showNotice('Add at least one product for the quote.');
            return;
          }
        }

        if (!validateContact() || !form.checkValidity()) {
          resetSubmitting();
          form.reportValidity();
          return;
        }

        const reference = createReference();
        referenceField.value = reference;
        contactNameField.value = [
          query('[name="contact[First name]"]')?.value,
          query('[name="contact[Last name]"]')?.value
        ].filter(Boolean).join(' ');
        productCountField.value = state.route === 'build'
          ? selectedValues('[data-package-product]').length
          : includedItems().length;
        quoteBodyField.value = buildQuoteBody();
        syncProductsNeededField();
        queryAll('[data-package-product]', form).forEach((field) => { field.disabled = true; });
        saveDraft();
        form.requestSubmit();
      });

      const refreshOnReturn = () => {
        if ((state.route === 'cart' || state.route === 'add') && !document.hidden) {
          refreshQuote({ preserveSelection: true, silent: true });
        }
      };
      window.addEventListener('focus', refreshOnReturn);
      window.addEventListener('pageshow', refreshOnReturn);
      document.addEventListener('visibilitychange', refreshOnReturn);
      document.addEventListener('rq:change', () => {
        if (state.isUpdatingCart || state.isAddingProduct) return;
        if (state.route !== 'cart' && state.route !== 'add') return;
        applyQuoteToState({ preserveSelection: true });
      });

      const postedSuccessfully = root.dataset.postedSuccessfully === 'true';
      if (postedSuccessfully) {
        const draft = readDraft();
        let reference = 'AQ-RECEIVED';
        try {
          reference = sessionStorage.getItem(`${storageKey}-reference`) || reference;
        } catch (error) {
          // Use the fallback reference when storage is unavailable.
        }
        const email = draft?.values?.['contact[email]'] || 'your email';
        startScreen.hidden = true;
        flowScreen.hidden = true;
        successScreen.hidden = false;
        query('[data-success-reference]').textContent = reference;
        query('[data-success-email]').textContent = email;
        closeProductModal();
        clearProductSearch();
        resetQuoteFlow();
        waitForRQ().then(applyRqClear).catch(() => {
          applyRqClear();
        });
        return;
      }

      const urlRoute = (() => {
        try {
          const route = new URLSearchParams(window.location.search).get('route');
          if (route === 'cart' || route === 'add' || route === 'build') return route;
        } catch (error) {
          // Ignore malformed URLs.
        }
        return '';
      })();

      const draft = readDraft();
      if (draft?.values) restoreValues(draft.values);
      syncProductsNeededField();
      syncPreferredContact();
      if (Array.isArray(draft?.includedKeys)) {
        state.includedKeys = new Set(draft.includedKeys);
        state.hasInclusionSelection = true;
      }
      if (draft?.reviewedSignature) state.reviewedSignature = draft.reviewedSignature;
      const cleanRouteParam = () => {
        try {
          const cleanUrl = new URL(window.location.href);
          cleanUrl.searchParams.delete('route');
          window.history.replaceState({}, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
        } catch (error) {
          // Keep the query param if history API is unavailable.
        }
      };

      // A saved draft (this tab already had this route/step open) always wins over the
      // ?route= param: it carries the exact step to resume, not just which route to start.
      // The URL param decides where to start when there is no local draft, e.g. "Continue
      // Quote" clicked from a page that never opened this section before.
      const resumeRoute = (draft?.route && draft?.panel) ? draft.route : urlRoute;

      const resumeToRoute = (route, panel) => {
        startRoute(route, { noScroll: true }).then(() => {
          if (state.route !== route) return;
          if (panel) showPanel(panel, { noScroll: true });
          if (urlRoute) cleanRouteParam();
        });
      };

      // The header trigger shows "manage" mode from RQ's own persisted state (items in
      // localStorage), independent of this tab's session draft. Without this fallback, landing
      // here with no draft and no ?route= (a bookmark, the nav link, a new tab) falls straight
      // to the start screen even though the header already reports an active quote — the header
      // and the page then visibly disagree about whether a quote exists. RQ's own script tag can
      // still be loading at this point, so this is the last resort and is awaited separately
      // rather than gating the fast, synchronous draft/urlRoute paths above.
      const resolveRqActiveRoute = async () => {
        try {
          await waitForRQ();
          const started = typeof window.RQ.isStarted === 'function' && window.RQ.isStarted();
          const hasItems = typeof window.RQ.getItemCount === 'function' && window.RQ.getItemCount() > 0;
          if (!started && !hasItems) return '';
          const route = typeof window.RQ.getRoute === 'function' ? window.RQ.getRoute() : 'add';
          return route === 'cart' || route === 'add' || route === 'build' ? route : 'add';
        } catch (error) {
          return '';
        }
      };

      if (root.dataset.hasErrors === 'true') {
        state.route = draft?.route || 'build';
        updateStepOneLabel();
        routeField.value = state.route === 'cart' ? 'Use my cart' : state.route === 'add' ? 'Add products' : 'Build my package';
        syncRouteControls();
        showPanel('contact', { noScroll: true });
      } else if (resumeRoute) {
        const resumePanel = (draft?.route === resumeRoute && draft?.panel)
          ? draft.panel
          : (resumeRoute === 'add' || resumeRoute === 'cart' ? resumeRoute : '');
        resumeToRoute(resumeRoute, resumePanel);
      } else {
        resolveRqActiveRoute().then((rqRoute) => {
          if (!rqRoute) {
            showStart();
            return;
          }
          resumeToRoute(rqRoute, rqRoute === 'add' || rqRoute === 'cart' ? rqRoute : '');
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-mirrors-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const frostImgs = {
      'No Frosting':
        'https://cdn.shopify.com/s/files/1/0424/4134/3137/files/custom-mirrors-page-No_Frosting.jpg?v=1760445767',
      'Edge Frosting':
        'https://cdn.shopify.com/s/files/1/0424/4134/3137/files/custom-mirrors-page-Edge_Frosting.jpg?v=1760445767',
      'Instep Frosting':
        'https://cdn.shopify.com/s/files/1/0424/4134/3137/files/custom-mirrors-page-Instep_Frosting.jpg?v=1760445767',
    };
    const lightImgs = {
      'Warm White 2700K':
        'https://cdn.shopify.com/s/files/1/0424/4134/3137/files/custom-mirrors-page-2700k.jpg?v=1760445768',
      'Standard White 4000K':
        'https://cdn.shopify.com/s/files/1/0424/4134/3137/files/custom-mirrors-page-4000k.jpg?v=1760445768',
      'Cool White 6500K':
        'https://cdn.shopify.com/s/files/1/0424/4134/3137/files/custom-mirrors-page-6500k.jpg?v=1760445767',
      'Adjustable 2700–6500K':
        'https://cdn.shopify.com/s/files/1/0424/4134/3137/files/custom-mirrors-page-4000k.jpg?v=1760445768',
    };

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function escapeHtml(value) {
      return String(value).replace(/[&<>"']/g, function (character) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
      });
    }

    function initMirrorBuilder(root) {
      const form = root.querySelector('.ap-mirror__form');
      const glass = root.querySelector('[data-preview-mirror]');
      const room = root.querySelector('[data-preview-room]');
      const frostEl = root.querySelector('[data-preview-frost]');
      const sensor = root.querySelector('[data-preview-sensor]');
      const mini = root.querySelector('[data-sensor-mini]');
      const photo = root.querySelector('[data-preview-photo]');
      const dimWidth = root.querySelector('[data-dim-width]');
      const dimHeight = root.querySelector('[data-dim-height]');
      const strip = root.querySelector('[data-selected-strip]');
      const bodyField = root.querySelector('[data-mirror-body]');
      const success = root.querySelector('[data-mirror-success]');

      if (!form || !glass) return;

      function field(name) {
        return form.querySelector('[data-mirror-field="' + name + '"]');
      }

      function checked(name) {
        return form.querySelector('[data-mirror-field="' + name + '"]:checked');
      }

      function features() {
        const selected = [];
        for (const input of form.querySelectorAll('[data-mirror-feature]:checked')) {
          selected.push(input.getAttribute('data-mirror-feature'));
        }
        return selected;
      }

      function show(el, on) {
        if (el) el.style.display = on ? 'flex' : 'none';
      }

      function moveDot(el, pos, transformCentre) {
        el.style.left = 'auto';
        el.style.right = 'auto';
        el.style.top = 'auto';
        el.style.bottom = el === mini ? '6px' : '8px';
        el.style.transform = 'none';
        if (pos === 'Bottom Centre') {
          el.style.left = '50%';
          el.style.transform = transformCentre || 'translateX(-50%)';
        }
        if (pos === 'Bottom Left') el.style.left = el === mini ? '7px' : '12%';
        if (pos === 'Bottom Right') el.style.right = el === mini ? '7px' : '12%';
        if (pos === 'Middle Left') {
          el.style.left = el === mini ? '7px' : '8px';
          el.style.top = '48%';
          el.style.bottom = 'auto';
        }
        if (pos === 'Middle Right') {
          el.style.right = el === mini ? '7px' : '8px';
          el.style.top = '48%';
          el.style.bottom = 'auto';
        }
      }

      function collectSpec() {
        const widthInput = field('width');
        const heightInput = field('height');
        return {
          shape: checked('shape') ? checked('shape').value : 'Rectangle / Square',
          width: clamp(Number(widthInput && widthInput.value) || 800, 300, 1000),
          height: clamp(Number(heightInput && heightInput.value) || 1000, 300, 2000),
          frosting: checked('frosting') ? checked('frosting').value : 'No Frosting',
          lighting: checked('lighting') ? checked('lighting').value : 'Standard White 4000K',
          control: checked('control') ? checked('control').value : 'Hardwired',
          sensor: field('sensor') ? field('sensor').value : 'Bottom Centre',
          features: features(),
          name: field('name') ? field('name').value.trim() : '',
          email: field('email') ? field('email').value.trim() : '',
          phone: field('phone') ? field('phone').value.trim() : '',
          postcode: field('postcode') ? field('postcode').value.trim() : '',
          notes: field('notes') ? field('notes').value.trim() : '',
        };
      }

      function formatBody(spec) {
        const featureList = spec.features.length ? spec.features.join(', ') : 'None';
        return [
          'Custom mirror quote',
          '',
          'Name: ' + spec.name,
          'Email: ' + spec.email,
          'Phone: ' + spec.phone,
          'Postcode: ' + spec.postcode,
          '',
          'Shape: ' + spec.shape,
          'Size: ' + spec.width + ' × ' + spec.height + ' mm',
          'Frosting: ' + spec.frosting,
          'Lighting: ' + spec.lighting,
          'Control: ' + spec.control,
          'Sensor location: ' + spec.sensor,
          'Features: ' + featureList,
          '',
          'Project notes:',
          spec.notes || '—',
        ].join('\n');
      }

      function render(animate) {
        const spec = collectSpec();

        for (const input of form.querySelectorAll('input[type="radio"], input[type="checkbox"]')) {
          const label = input.closest('label');
          if (label) label.dataset.selected = input.checked ? 'true' : 'false';
        }

        const sceneHeight = room.clientHeight || 350;
        const sceneScale = sceneHeight / 350;
        const scale = 0.105 * sceneScale;
        const base = Math.round(118 * sceneScale);
        const drawW = Math.round(spec.width * scale);
        const drawH = Math.round(spec.height * scale);
        const radius =
          spec.shape === 'Round'
            ? '50%'
            : spec.shape.indexOf('Rounded') === 0
            ? '18px'
            : spec.shape.indexOf('Oblong') === 0
            ? spec.shape.indexOf('2') > -1
              ? '36px'
              : '45%'
            : spec.shape.indexOf('Arch') === 0
            ? spec.shape.indexOf('2') > -1
              ? '28px 28px 5px 5px'
              : '50% 50% 6px 6px'
            : '4px';
        const glow =
          spec.lighting.indexOf('Warm') === 0
            ? '#ffd797'
            : spec.lighting.indexOf('Cool') === 0
            ? '#c8e7ff'
            : spec.lighting.indexOf('Adjustable') === 0
            ? '#fff0bd'
            : '#fff';

        glass.style.width = drawW + 'px';
        glass.style.height = drawH + 'px';
        glass.style.borderRadius = radius;
        glass.style.boxShadow = '0 0 28px 9px ' + glow + ', 0 14px 24px rgba(72,55,43,.24)';
        frostEl.style.borderWidth =
          spec.frosting === 'Edge Frosting' ? '10px' : spec.frosting === 'Instep Frosting' ? '7px' : '0';
        frostEl.style.inset = spec.frosting === 'Instep Frosting' ? '10px' : '0';
        moveDot(sensor, spec.sensor);
        if (mini) moveDot(mini, spec.sensor, 'translateX(-50%)');
        show(root.querySelector('[data-preview-demister]'), spec.features.indexOf('Demister') > -1);
        show(root.querySelector('[data-preview-makeup]'), spec.features.indexOf('Mirage makeup mirror') > -1);
        show(root.querySelector('[data-preview-speaker]'), spec.features.indexOf('Bluetooth speakers') > -1);

        dimWidth.textContent = '↔ ' + spec.width + ' mm W';
        dimWidth.style.width = drawW + 'px';
        dimWidth.style.bottom = base + drawH + 8 + 'px';
        dimHeight.textContent = '↕ ' + spec.height + ' mm H';
        dimHeight.style.height = drawH + 'px';
        dimHeight.style.left = 'calc(50% + ' + (Math.round(drawW / 2) + 8) + 'px)';
        dimHeight.style.bottom = base + 'px';

        const photoSrc =
          spec.frosting === 'No Frosting' ? lightImgs[spec.lighting] || frostImgs[spec.frosting] : frostImgs[spec.frosting];
        if (photo && photo.src !== photoSrc) photo.src = photoSrc;

        root.querySelector('[data-sum="shape"]').textContent = spec.shape;
        root.querySelector('[data-sum="size"]').textContent = spec.width + ' × ' + spec.height + ' mm';
        root.querySelector('[data-sum="frost"]').textContent = spec.frosting;
        root.querySelector('[data-sum="light"]').textContent = spec.lighting;
        root.querySelector('[data-sum="control"]').textContent = spec.control + ' · ' + spec.sensor;
        root.querySelector('[data-sum="features"]').textContent = spec.features.length
          ? spec.features.join(', ')
          : 'None selected';

        if (strip) {
          const chips = [
            spec.shape,
            'W ' + spec.width + ' mm',
            'H ' + spec.height + ' mm',
            spec.frosting,
            spec.lighting,
            spec.control,
            spec.sensor,
          ].concat(spec.features);
          let html = '';
          for (const chip of chips) {
            html += '<span class="ap-mirror__chip">' + escapeHtml(chip) + '</span>';
          }
          strip.innerHTML = html;
        }

        if (bodyField) bodyField.value = formatBody(spec);

        if (animate !== false) {
          room.classList.remove('is-changing');
          void room.offsetWidth;
          room.classList.add('is-changing');
        }
      }

      function shouldRenderPreview(event) {
        const target = event.target;
        if (!target || !target.closest) return true;
        if (target.closest('.ap-mirror__contact')) return false;
        const fieldName = target.getAttribute('data-mirror-field');
        return fieldName !== 'name' && fieldName !== 'email' && fieldName !== 'phone' && fieldName !== 'postcode' && fieldName !== 'notes';
      }

      function onFormUpdate(event) {
        if (!shouldRenderPreview(event)) return;
        render();
      }

      function prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      function stickyOffset() {
        const styles = getComputedStyle(document.documentElement);
        const header = parseFloat(styles.getPropertyValue('--header-height')) || 0;
        const announcement = parseFloat(styles.getPropertyValue('--announcement-bar-height')) || 0;
        const isSticky = parseFloat(styles.getPropertyValue('--header-is-sticky')) || 0;
        return (header + announcement) * isSticky + 24;
      }

      function scrollPastHeader(element) {
        if (!element) return;
        const target = element.closest('label') || element;
        const top = target.getBoundingClientRect().top + window.scrollY - stickyOffset();
        window.scrollTo({
          top: Math.max(0, top),
          behavior: prefersReducedMotion() ? 'auto' : 'smooth',
        });
        if (typeof element.focus === 'function') {
          element.focus({ preventScroll: true });
        }
      }

      function scrollToAlert(element) {
        scrollPastHeader(element);
      }

      let invalidScrollScheduled = false;
      form.addEventListener(
        'invalid',
        function (event) {
          if (invalidScrollScheduled) return;
          invalidScrollScheduled = true;
          const field = event.target;
          window.setTimeout(function () {
            scrollPastHeader(field);
            invalidScrollScheduled = false;
          }, 50);
        },
        true
      );

      function revealSuccess() {
        if (!success) return;
        success.hidden = false;
        success.removeAttribute('hidden');
        form.reset();
        render();
        scrollToAlert(success);
      }

      function ensureReturnTo() {
        const contactSection = root.querySelector('.ap-mirror__contact');
        const anchor = contactSection && contactSection.id ? '#' + contactSection.id : '';
        const returnUrl = window.location.pathname + '?contact_posted=true' + anchor;
        let returnInput = form.querySelector('input[name="return_to"]');
        if (!returnInput) {
          returnInput = document.createElement('input');
          returnInput.type = 'hidden';
          returnInput.name = 'return_to';
          form.insertBefore(returnInput, form.firstChild);
        }
        returnInput.value = returnUrl;
      }

      form.addEventListener('input', onFormUpdate);
      form.addEventListener('change', onFormUpdate);
      form.addEventListener('submit', function () {
        const spec = collectSpec();
        if (bodyField) bodyField.value = formatBody(spec);
        ensureReturnTo();
        const button = form.querySelector('[data-mirror-submit]');
        if (button) {
          button.disabled = true;
          button.textContent = button.getAttribute('data-sending-label') || 'Sending…';
        }
      });

      ensureReturnTo();
      render();

      let resizeTimer = 0;
      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          render(false);
        }, 100);
      });

      const postedFromUrl = new URLSearchParams(window.location.search).get('contact_posted') === 'true';
      if (success && !success.hidden) {
        form.reset();
        render();
        scrollToAlert(success);
      } else if (postedFromUrl) {
        revealSuccess();
      } else {
        const errorAlert = root.querySelector('.ap-mirror__alert--error');
        if (errorAlert) scrollToAlert(errorAlert);
      }
    }

    function boot() {
      const builders = document.querySelectorAll('[data-mirror-builder]');
      for (const builder of builders) initMirrorBuilder(builder);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["empty-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function normalizeHash(hash) {
      return (hash || '').replace(/^#/, '').toLowerCase().trim();
    }

    function initEmptyBanner(root) {
      if (!root || root.dataset.ebReady === 'true') return;
      root.dataset.ebReady = 'true';

      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-eb-hash]'));
      if (!cards.length) return;

      var hashes = cards.map(function (card) {
        return normalizeHash(card.getAttribute('data-eb-hash'));
      });
      var defaultHash = normalizeHash(root.getAttribute('data-default-hash')) || hashes[0];
      var currentHash = null;

      function syncPanels(hash) {
        var panels = document.querySelectorAll('[data-eb-panel]');
        panels.forEach(function (panel) {
          var match = normalizeHash(panel.getAttribute('data-eb-panel')) === hash;
          panel.hidden = !match;
          panel.classList.toggle('is-active', match);
        });
      }

      function setActive(hash, options) {
        options = options || {};
        var next = hashes.indexOf(hash) !== -1 ? hash : defaultHash;
        var changed = currentHash !== null && currentHash !== next;

        cards.forEach(function (card) {
          var selected = normalizeHash(card.getAttribute('data-eb-hash')) === next;
          card.classList.toggle('is-active', selected);
          card.setAttribute('aria-selected', selected ? 'true' : 'false');
          card.tabIndex = selected ? 0 : -1;
        });

        syncPanels(next);

        if (options.updateHash !== false) {
          var newHash = '#' + next;
          if (window.location.hash !== newHash) {
            if (options.replace) {
              history.replaceState(null, '', newHash);
            } else {
              history.pushState(null, '', newHash);
            }
          }
        }

        if (changed || options.forceEvent) {
          root.dispatchEvent(
            new CustomEvent('empty-banner:change', {
              bubbles: true,
              detail: { hash: next, sectionId: root.getAttribute('data-section-id') }
            })
          );
        }

        currentHash = next;
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function (event) {
          event.preventDefault();
          setActive(normalizeHash(card.getAttribute('data-eb-hash')));
        });

        card.addEventListener('keydown', function (event) {
          var index = cards.indexOf(card);
          var nextIndex = index;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            nextIndex = (index + 1) % cards.length;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            nextIndex = (index - 1 + cards.length) % cards.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = cards.length - 1;
          } else if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setActive(normalizeHash(card.getAttribute('data-eb-hash')));
            return;
          } else {
            return;
          }

          event.preventDefault();
          cards[nextIndex].focus();
          setActive(normalizeHash(cards[nextIndex].getAttribute('data-eb-hash')));
        });
      });

      window.addEventListener('hashchange', function () {
        setActive(normalizeHash(window.location.hash), { updateHash: false, forceEvent: true });
      });

      setActive(normalizeHash(window.location.hash), {
        replace: true,
        updateHash: true,
        forceEvent: true
      });
    }

    function initAll() {
      document.querySelectorAll('[data-section-type="empty-banner"]').forEach(initEmptyBanner);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-section-type="empty-banner"]');
      if (root) {
        root.dataset.ebReady = 'false';
        initEmptyBanner(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-compare"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.before-after-slider-section .containered');

  containers.forEach((container) => {
    const slider = container.querySelector('.slider');
    slider.addEventListener('input', (e) => {
      container.style.setProperty('--position', `${e.target.value}%`);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trade-account-sign-ins"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ROUTES = ['sign-in', 'existing-trade', 'new-trade'];

    function normalizeHash(hash) {
      return (hash || '').replace(/^#/, '').toLowerCase().trim();
    }

    function initTradeSignIns(root) {
      if (!root || root.dataset.tsiReady === 'true') return;
      root.dataset.tsiReady = 'true';

      var startScreen = root.querySelector('[data-screen="start"]');
      var detailScreen = root.querySelector('[data-screen="detail"]');
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));
      var updatingHash = false;

      function scrollToSection() {
        var styles = getComputedStyle(document.documentElement);
        var headerHeight =
          (parseFloat(styles.getPropertyValue('--header-height')) || 0) +
          (parseFloat(styles.getPropertyValue('--announcement-bar-height')) || 0);
        var isSticky = parseFloat(styles.getPropertyValue('--header-is-sticky')) || 0;
        var offset = headerHeight * isSticky + 24;
        var top = root.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
          top: Math.max(0, top),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      function showStart(options) {
        options = options || {};
        if (startScreen) startScreen.hidden = false;
        if (detailScreen) detailScreen.hidden = true;
        panels.forEach(function (panel) {
          panel.hidden = true;
        });

        if (options.updateHash !== false) {
          updatingHash = true;
          if (window.location.hash) {
            if (options.replace) {
              history.replaceState(null, '', window.location.pathname + window.location.search);
            } else {
              history.pushState(null, '', window.location.pathname + window.location.search);
            }
          }
          updatingHash = false;
        }

        if (!options.noScroll) {
          scrollToSection();
        }
      }

      function showRoute(route, options) {
        options = options || {};
        if (ROUTES.indexOf(route) === -1) {
          showStart(options);
          return;
        }

        if (startScreen) startScreen.hidden = true;
        if (detailScreen) detailScreen.hidden = false;
        panels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-panel') !== route;
        });

        if (options.updateHash !== false) {
          var nextHash = '#' + route;
          if (window.location.hash !== nextHash) {
            updatingHash = true;
            var nextUrl = window.location.pathname + window.location.search + nextHash;
            if (options.replace) {
              history.replaceState(null, '', nextUrl);
            } else {
              history.pushState(null, '', nextUrl);
            }
            updatingHash = false;
          }
        }

        if (!options.noScroll) {
          scrollToSection();
        }
      }

      function syncFromHash(options) {
        options = options || {};
        var hash = normalizeHash(window.location.hash);
        if (ROUTES.indexOf(hash) !== -1) {
          showRoute(hash, Object.assign({ updateHash: false }, options));
        } else {
          showStart(Object.assign({ updateHash: false }, options));
        }
      }

      root.querySelectorAll('[data-route]').forEach(function (button) {
        button.addEventListener('click', function () {
          showRoute(button.getAttribute('data-route'));
        });
      });

      root.querySelectorAll('[data-back-start]').forEach(function (button) {
        button.addEventListener('click', function () {
          showStart();
        });
      });

      window.addEventListener('hashchange', function () {
        if (updatingHash) return;
        syncFromHash({ noScroll: false });
      });

      window.addEventListener('popstate', function () {
        if (updatingHash) return;
        syncFromHash({ noScroll: true });
      });

      syncFromHash({ noScroll: true, replace: true });
    }

    function initAll() {
      document.querySelectorAll('[data-section-type="trade-sign-ins"]').forEach(initTradeSignIns);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target && event.target.querySelector
        ? event.target.querySelector('[data-section-type="trade-sign-ins"]')
        : null;
      if (root) {
        root.dataset.tsiReady = 'false';
        initTradeSignIns(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
